import { lazy, Suspense } from "react";
import { Route, Routes, Navigate, useParams } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
// import ARViewer from "./components/SmartObject/ArViewer";
import { AnimatedLoader } from "./components/Loader/AnimatedLoader";
import NotFound from "./screens/NotFound";
// import ArViewerStandalone from "./components/SmartObject/ArViewerWrapperStandalone";
export const CONFIGURATOR_VIEWER = "/configurator/:modelId";

const ConfiguratorViewer = lazy(() => import("./components/ConfiguratorViewer/ConfiguratorViewerV2"));
const SmartObject = lazy(() => import("./components/SmartObject/SmartObject"));
const ARViewer = lazy(() => import("./components/SmartObject/ArViewer"));
const ArViewerStandalone = lazy(() => import("./components/SmartObject/ArViewerWrapperStandalone"));

const routeMapFunc = (
  { exact = true, path, Component, componentProps, routes },
  idx
) => {
  return (
    <Route
      path={path}
      exact={exact}
      element={<Component {...componentProps} />}
      key={idx}
    >
      {routes?.map(routeMapFunc)}
    </Route>
  );
};

export const routes = [
  // { path: CONFIGURATOR_VIEWER, Component: ConfiguratorViewer, key: "viewer" },
  { path: '/', Component: () => <Navigate to="/1" replace />, key: 'root-redirect'},
  { path: '/:modelId', Component: SmartObject, key: 'smart',},
  { path: '/ar/preview/:token', Component: ArViewerStandalone, key: 'ARViewer'},
  { path: '*', Component: NotFound, key: 'not-found' },
];

export const Routing = () => {
  return (
    <ErrorBoundary>
      {/* <Suspense fallback={<AnimatedLoader zIndex={1000} loading={true} className="bg-white" position="fixed" />}> */}
        <Routes>{routes.map(routeMapFunc)}</Routes>
        {/* <Route
          path="/ar/preview/:token"
          element={<ARViewer />}
        /> */}
      {/* </Suspense> */}
    </ErrorBoundary>
  );
};
